import { observer } from 'mobx-react-lite';
import LanguageStore from '../store/LanguageStore';
import JsonLd from '../components/JsonLd/JsonLd';
import { createAboutPageSchema } from '../utils/jsonLdSchemas';
import './about-us-page.scss';

const AboutUsPage = observer(() => {
    const { t, language } = LanguageStore;
    const siteUrl = window.location.origin;
    
    // Создаем JSON-LD схему для страницы "О нас"
    const aboutSchema = createAboutPageSchema(
        siteUrl,
        t('aboutUsTitle'),
        t('aboutUsDescription'),
        language
    );

    return (
        <article className="about-us-page">
            <JsonLd data={aboutSchema} id="json-ld-about" />
            <div className="container">
                <div className="about-us-page__content">
                    <h1 className="about-us-page__title">
                        <span className="about-us-page__title-text">{t('aboutUsTitle')} </span>
                        <span className="about-us-page__title-emoji">🚀</span>
                    </h1>
                    
                    <div className="about-us-page__description">
                        {t('aboutUsDescription')}
                    </div>

                    <div className="about-us-page__section">
                        <h2 className="about-us-page__section-title">
                            {t('aboutUsSection1Title')}
                        </h2>
                        <p className="about-us-page__section-text">
                            {t('aboutUsSection1Text')}
                        </p>
                    </div>

                    <div className="about-us-page__section">
                        <h2 className="about-us-page__section-title">
                            {t('aboutUsSection2Title')}
                        </h2>
                        <p className="about-us-page__section-text">
                            {t('aboutUsSection2Text')}
                        </p>
                    </div>

                    <div className="about-us-page__section">
                        <h2 className="about-us-page__section-title">
                            {t('aboutUsSection3Title')}
                        </h2>
                        <p className="about-us-page__section-text">
                            {t('aboutUsSection3Text')}
                        </p>
                    </div>

                    <section className="project-idea">
                        <h4 className="project-idea__title">{t('projectIdeaTitle')}</h4>
                        <p className="project-idea__description">
                            {t('projectIdeaDescription')}
                        </p>
                        <div className="project-idea__author">
                            <a 
                                href="https://t.me/AlexandrTLT" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="project-idea__author-link"
                            >
                                {t('projectIdeaAuthor')}
                            </a>
                        </div>
                    </section>
                </div>
            </div>
        </article>
    );
});

export default AboutUsPage;
